//functional imports
// import React, { useState } from 'react';
//custom componets
import Home from "./pages/home/index.js"
//main css
import './App.css';



const App=()=>{
  return (
    <Home/>
  );
}

export default App;
